module.exports = __webpack_public_path__ + "img/blog3.5db966e7.png";